import apiInstance from './api.instance';
export const fetchNotifications = async (merchantNum, pageNumber = 1, pageSize = 10, readStatus, language) => {
    try {
        const response = await apiInstance.post(
        // using this base URL as a template literal to override the base url in our API instance
        `${process.env.NOTIFICATION_URL}/${merchantNum}/fetch`, {
            pageNumber,
            pageSize,
            readStatus,
            language,
        });
        return response.data ?? null;
    }
    catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
    }
};
export const markNotificationRead = async (merchantNum, notificationUuid, markAllRead) => {
    try {
        const response = await apiInstance.post(`${process.env.NOTIFICATION_URL}/${merchantNum}/read`, {
            notificationUuid: notificationUuid,
            markAllRead: markAllRead,
        });
        return response.data;
    }
    catch (error) {
        console.error('Error marking notifications:', error);
        throw error;
    }
};
export const deleteNotification = async (merchantNum, notificationUuid) => {
    try {
        const response = await apiInstance.post(`${process.env.NOTIFICATION_URL}/${merchantNum}/delete`, {
            notificationUuid: notificationUuid,
        });
        return response.data;
    }
    catch (error) {
        console.error('Error fetching notifications:', error);
        throw error;
    }
};
/**
 * Fetches carousel notifications by date DESC
 */
export const fetchCarouselNotifications = async (merchantNum, numOfMessages = 3, language) => {
    try {
        const response = await apiInstance.post(`${process.env.NOTIFICATION_URL}/${merchantNum}/carousel/fetch`, {
            numOfMessages,
            language,
        });
        return response.data;
    }
    catch (error) {
        console.error('Error fetching carousel notifications:', error);
        throw error;
    }
};
export const carouselDismiss = async (merchantNum, notificationUuid) => {
    try {
        const response = await apiInstance.post(`${process.env.NOTIFICATION_URL}/${merchantNum}/carousel/dismiss`, {
            notificationUuid: notificationUuid,
        });
        return response.data;
    }
    catch (error) {
        console.error('Error dismissing notification:', error);
        throw error;
    }
};
